export const PRODUCT_TYPES = {
  shoes: 'shoes',
  apparel: 'apparel',
  accessories: 'accessories',
  giftCards: 'gift_cards',
  magazine: 'magazine',
}

export const PRODUCT_SUBTYPES = {
  active: 'active',
  allDay: 'all_day',
  bags: 'bags',
  bottoms: 'bottoms',
  hats: 'hats',
  jackets: 'jackets',
  race: 'race',
  socks: 'socks',
  support: 'support',
  tops: 'tops',
  trail: 'trail',
  training: 'training',
  digital: 'digital',
  hiking: 'hiking',
  classics: 'classics',
  magazine: 'magazine',
  bottles: 'bottles',
  towels: 'towels',
  sportsBras: 'sports-bras',
}

export const MEDIA_GALLERY_POSITIONS = {
  nearBottom: 'near-bottom',
  belowPurchasePod: 'below-purchase-pod',
  hidden: 'hidden',
}
